import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-query';

import content from './config/data/table/content.csv';
import boardType from './config/data/table/BoardType.csv';
import boardCustomType from './config/data/table/boardCustomType.csv';
import sns from './config/data/table/sns.csv';
import watch from './config/data/table/watch.csv';
import overseas_en from './config/data/table/overseas_en.csv';
import overseas_ko from './config/data/table/overseas_ko.csv';
import department from './config/data/table/department.csv';
import loadCustomer from './localization/csv_convert';
import setTableDataFile from './localization/data_read';
import { Mki18n } from './localization/i18n';
import Structure from './routes/Structure';
import ErrorPage from './routes/common/ErrorPage';

const App = () => {
  let { mode } = useSelector((state) => state);

  const { status, data, isLoading, error } = useQuery('localText', loadCustomer, {
    suspense: false,
    staleTime: Infinity,
    cacheTime: Infinity,
  });
  const contentTable = useQuery('content', () => setTableDataFile(content), {
    staleTime: Infinity,
    cacheTime: Infinity,
  });
  const boardTypeTable = useQuery('boardType', () => setTableDataFile(boardType), {
    staleTime: Infinity,
    cacheTime: Infinity,
  });
  const boardCustomTypeData = useQuery('boardCustomType', () => setTableDataFile(boardCustomType), {
    staleTime: Infinity,
    cacheTime: Infinity,
  });
  const managerTable = useQuery('content', () => setTableDataFile(content), {
    staleTime: Infinity,
    cacheTime: Infinity,
  });
  const snsTable = useQuery('sns', () => setTableDataFile(sns), { staleTime: Infinity, cacheTime: Infinity });

  const watchTable = useQuery('watch', () => setTableDataFile(watch), { staleTime: Infinity, cacheTime: Infinity });

  const overseasEnTable = useQuery('overseas_en', () => setTableDataFile(overseas_en), {
    staleTime: Infinity,
    cacheTime: Infinity,
  });
  const overseasKoTable = useQuery('overseas_ko', () => setTableDataFile(overseas_ko), {
    staleTime: Infinity,
    cacheTime: Infinity,
  });

  const departmentTable = useQuery('department', () => setTableDataFile(department), {
    staleTime: Infinity,
    cacheTime: Infinity,
  });

  useEffect(() => {
    if (data) Mki18n(data, mode);
  }, [data, mode]);

  // if (isLoading) {
  //   return <>접속중...</>;
  // }
  if (error) {
    return <ErrorPage error={error.code} errorInfo={error.message}></ErrorPage>;
  }

  return (
    // basename={process.env.PUBLIC_URL}
    <Router forceRefresh={false}>
      <Structure mode={mode} />
    </Router>
    // </Suspense>
  );
};

export default withTranslation()(App);
